import {
  useQuery,
  useMutation,
  useQueryClient,
  UseQueryResult,
} from '@tanstack/react-query';
import { Logs, LogService } from '../services/LogService';

import { createLogger } from '@xanectech/lib';

const logger = createLogger('Supabase-Client - useLogs');

/**
 * Hook to fetch and manage logs using the LogService.
 * Ensures privacy by not exposing sensitive data in logs or errors.
 */
export const useLogs = (): UseQueryResult<Logs> => {
  return useQuery({
    queryKey: ['logs'],
    queryFn: () => LogService.getAllLogs(),
  });
};

export const useCreateLog = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: LogService.createLog,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['logs'] });
    },
    onError: (error) => {
      logger.error('Error creating log entry:', error);
    },
  });
};
